export const columns = [{
  title: 'Message',
  dataIndex: 'message',
  sorter: (a,b) => a.message.localeCompare(b.message)
}, {
  title: 'Ticker',
  dataIndex: 'ticker',
  sorter: (a,b) => a.ticker.localeCompare(b.ticker)
}, {
  title: 'Start Date',
  dataIndex: 'date',
  sorter: (a,b) => new Date(a.date) - new Date(b.date)
}, {
  title: 'End Date',
  dataIndex: 'end_date',
  sorter: (a,b) => new Date(a.end_date) - new Date(b.end_date)
}]
